import React, { useEffect, useRef, useState } from 'react';
import InputMask from 'react-input-mask';

import { validationAndUpdateValue } from 'apps/auth/components/form-multi/utils';
import { CODE } from 'apps/auth/constants/fieldsName';
import { logInfo } from 'apps/auth/helpers/clientLogger';
import { inputPropType } from 'apps/auth/helpers/customPropTypes';

import { PinContainer, PinInputContainer, PinInputUnderline } from './NewInputSmsStyles';

const NewInputSms = (props) => {
    const [fieldValue, setFieldValue] = useState();
    const [inputs, setInputs] = useState({
        input_1: '',
        input_2: '',
        input_3: '',
        input_4: '',
        input_5: '',
        input_6: '',
    });
    const first = useRef(null);
    const second = useRef(null);
    const third = useRef(null);
    const fourth = useRef(null);
    const fifth = useRef(null);
    const sixth = useRef(null);

    const field = props.field;

    const helper = {
        1: {
            name: '1',
            input: {
                name: 'input_1',
                value: inputs.input_1,
            },
            ref: first,
        },
        2: {
            name: '2',
            input: {
                name: 'input_2',
                value: inputs.input_2,
            },
            ref: second,
        },
        3: {
            name: '3',
            input: {
                name: 'input_3',
                value: inputs.input_3,
            },
            ref: third,
        },
        4: {
            name: '4',
            input: {
                name: 'input_4',
                value: inputs.input_4,
            },
            ref: fourth,
        },
        5: {
            name: '5',
            input: {
                name: 'input_5',
                value: inputs.input_5,
            },
            ref: fifth,
        },
        6: {
            name: '6',
            input: {
                name: 'input_6',
                value: inputs.input_6,
            },
            ref: sixth,
        },
    };

    useEffect(() => {
        first.current?.focus();
    }, [first.current]);

    useEffect(() => {
        if (!field?.value) {
            const newInputs = {};
            Object.keys(inputs).forEach((key) => (newInputs[key] = ''));
            setInputs(newInputs);
            first.current?.focus();
        }
    }, [field?.value]);

    useEffect(() => {
        validationAndUpdateValue(props.formName, fieldValue, field, props.changeFormField);
    }, [fieldValue]);

    useEffect(() => {
        const isFilled = Object.values?.(inputs).every((value) => value !== '');
        if (isFilled) {
            const fieldVal = Object.values?.(inputs).join('');
            setFieldValue(fieldVal);
        }
    }, [inputs]);

    useEffect(() => {
        if ('OTPCredential' in window) {
            const input = document.querySelector('input[autocomplete="one-time-code"]');
            if (!input) return;
            // Cancel the WebOTP API if the form is submitted manually.
            const ac = new AbortController();
            // Invoke the WebOTP API
            logInfo('Invoke the WebOTP API', navigator);
            if (navigator && navigator.credentials) {
                logInfo('navigator.credentials:', navigator.credentials);
                navigator.credentials
                    .get({
                        otp: { transport: ['sms'] },
                        signal: ac.signal,
                    })
                    .then((otp) => {
                        logInfo('otp:', otp);
                        changeWebOptValue(otp.code);
                    })
                    .catch((err) => {
                        logInfo(err);
                    });
            }
        }
    }, []);

    const changeWebOptValue = (currentValue) => {
        logInfo('currentValue event:', currentValue);
        const value = currentValue ? currentValue.replace(/\D/g, '') : '';
        const newInputs = {};
        Object.keys(inputs).forEach((key, i) => {
            newInputs[key] = value[i];
        });
        setInputs(newInputs);
    };

    const onChangeHandler = ({ target: { name, value } }, inputName) => {
        if (props.isError) {
            props.removeFieldError(props.formName, CODE);
            props.changeFormFieldValue(props.formName, '', CODE);
        }
        setInputs((prevInputs) => ({
            ...prevInputs,
            [inputName]: value,
        }));
        if (value && name !== '6') {
            setFocus(name);
        }
    };

    const setFocus = (name, back = false) => {
        const currPosition = +name;
        const nextPosition = back ? currPosition - 1 : currPosition + 1;
        const newRefContainer = helper[String(nextPosition)].ref;
        newRefContainer.current.focus();
    };

    const onKeyDownHandler = ({ key, target: { value, name } }) => {
        if (key === 'Backspace' && name !== '1' && !value) {
            setFocus(name, true);
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const paste = e.clipboardData.getData('text').replace(/\D/g, '');

        const newInputs = {};
        Object.keys(inputs).forEach((key, i) => (newInputs[key] = paste[i]));
        setInputs(newInputs);
    };

    return (
        <>
            <PinContainer>
                {Object.values(helper).map(({ name, input, ref }, index) => {
                    return (
                        <PinInputContainer key={`${name}${index}`}>
                            <InputMask
                                mask={'9'}
                                maskChar={null}
                                value={input?.value || ''}
                                name={name}
                                onKeyDown={(e) => onKeyDownHandler(e)}
                                onChange={(e) => onChangeHandler(e, input.name)}
                                autoComplete="one-time-code"
                                onPaste={handlePaste}
                            >
                                {(inputProps) => <input {...inputProps} ref={ref} inputMode="numeric" />}
                            </InputMask>
                            <PinInputUnderline $isError={props.isError} />
                        </PinInputContainer>
                    );
                })}
            </PinContainer>
        </>
    );
};

NewInputSms.propTypes = inputPropType(['text', 'tel']);

export default NewInputSms;
